export const countryType = {
  1: 'South Korea',
  2: 'Japan',
  8: 'Mongolia',
  9: 'Philippines',
  13: 'Viet Nam',
  14: 'Kyrgyzstan',
  15: 'Cambodia',
  17: 'Uzbekistan',
  28: 'Kazakhstan',
  30: 'United States',
  31: 'Canada',
  61: 'United Kingdom',
  63: 'Russian Federation',
  67: 'France',
  68: 'Germany',
  83: 'Switzerland',
  111: 'Qatar',
};

export const countryList = [
  {c_idx : 1, c_number: 82, CO_NAME_KOR : 'South Korea'}, //대한민국
  {c_idx : 2, c_number: 81, CO_NAME_KOR : 'Japan'}, //일본
  {c_idx : 8, c_number: 976, CO_NAME_KOR : 'Mongolia'}, //몽골
  {c_idx : 9, c_number: 63, CO_NAME_KOR : 'Philippines'}, //필리핀
  {c_idx : 13, c_number: 84, CO_NAME_KOR : 'Viet Nam'}, //베트남
  {c_idx : 14, c_number: 996, CO_NAME_KOR : 'Kyrgyzstan'}, //키르기스스탄
  {c_idx : 15, c_number: 855, CO_NAME_KOR : 'Cambodia'}, //캄보디아
  {c_idx : 17, c_number: 998, CO_NAME_KOR : 'Uzbekistan'}, //우즈베키스탄
  {c_idx : 28, c_number: 7, CO_NAME_KOR : 'Kazakhstan'}, //카자흐스탄
  {c_idx : 30, c_number: 1, CO_NAME_KOR : 'United States'}, //미국
  {c_idx : 31, c_number: 1, CO_NAME_KOR : 'Canada'}, //캐나다
  {c_idx : 61, c_number: 44, CO_NAME_KOR : 'United Kingdom'}, //영국
  {c_idx : 63, c_number: 7, CO_NAME_KOR : 'Russian Federation'}, //러시아
  {c_idx : 67, c_number: 33, CO_NAME_KOR : 'France'}, //프랑스
  {c_idx : 68, c_number: 49, CO_NAME_KOR : 'Germany'}, //독일
  {c_idx : 83, c_number: 41, CO_NAME_KOR : 'Switzerland'}, //스위스
  {c_idx : 111, c_number: 974, CO_NAME_KOR : 'Qatar'}, //카타르
];
